import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { USERS_PATH } from '../../config';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Error guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const ErrorGuard = ({ children }) => {
    const { isLoggedIn, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn && user?.confirmed && user?.data !== null) {
            navigate(USERS_PATH, { replace: true });
        }
    }, [isLoggedIn, navigate, user?.confirmed, user?.data]);

    return children;
};

ErrorGuard.propTypes = {
    children: PropTypes.node
};

export default ErrorGuard;
